<template>
    <footer :class="[
        'layout-footer',
        layoutClasses
    ]">
        <div class="wrapper wrapper--relative flex">
            <div class="flex flex-space-35">
                <div
                    v-bastards
                    class="fs-13 text-color-light"
                >
                    © MAKRO Cash and Carry Polska S.A.
                </div>
                <NavigationFooter
                    :items="navItems"
                    class="fs-13 text-color-light"
                />
            </div>
            <!-- <div class="fs-13 text-color-light">
                realizacja:
                <a
                    href="https://www.visualmedia.pl"
                    target="_blank"
                    title="agencja interaktywna Visual Media"
                    class="link-underline-in"
                    rel="noreferrer"
                >
                    agencja interaktywna Visual Media
                </a>
            </div> -->
        </div>
    </footer>
</template>

<script>
import NavigationFooter from '@/components/navigation/NavigationFooter'

export default {
    components: {
        NavigationFooter
    },

    computed: {
        layoutClasses() {
            return this.$store.getters['layout/layoutClasses']
        },

        // isPageSampling() {
        //     return this.$route.name === 'sampling'
        // },

        navItems() {
            let out = [
                {
                    url: 'https://www.makro.pl/faq',
                    title: 'FAQ'
                },
                {
                    url: 'https://www.makro.pl/polityka-prywatnosci',
                    title: 'Polityka prywatności',
                    target: '_blank'
                },{
                    url: 'https://www.makro.pl/o-makro/informacje-prawne',
                    title: 'Informacje prawne',
                    target: '_blank'
                },
                {
                    url: 'https://www.makro.pl/pliki-cookie',
                    title: 'Cookies'
                },
                {
                    url: 'https://www.makro.pl/o-makro',
                    title: 'O MAKRO'
                }
            ]

            // if (this.isPageSampling) {
            //     out = [
            //         {
            //             url: '/uploads/Makro_REGULAMIN-sampling.pdf',
            //             title: 'Regulamin promocji'
            //         }
            //     ].concat(out)
            // }

            return out
        }
    }
}
</script>

<style lang="scss" scoped>
.layout-footer {
    padding: 13px 0 50px;

    .is-ie & {
        .flex {
            display: block;
        }

        .navigation-footer {
            display: inline-block;
        }

        .wrapper {
            > .flex {
                > * {
                    display: inline-block;
                }
            }
        }
    }

    .wrapper {
        &:before {
            content: '';
            background-color: $color-border-light;
            position: absolute;
            top: -13px;
            left: 0;
            right: 0;
            height: 1px;
        }
    }

    &.is-simple {
        > .wrapper {
            justify-content: center;

            &:before {
                background-color: $color-bg;
                top: -14px;
            }
        }
    }

    @media (max-width: $screen-mobile-landscape) {
        .wrapper {
            > .flex {
                display: block;
                text-align: center;
                width: 100%;

                .navigation-footer {
                    margin: 8px auto 0;
                }
            }
        }
    }
}
</style>
